import React from 'react'

export const PoliciesAndCredentialsIcon = (): JSX.Element => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="File" clipPath="url(#clip0_522_3446)">
      <path
        id="Vector"
        d="M17.648 5.01339L12.8444 0.209821C12.7105 0.0758929 12.5297 0 12.34 0H2.85784C2.46275 0 2.14355 0.319196 2.14355 0.714286V19.2857C2.14355 19.6808 2.46275 20 2.85784 20H17.1436C17.5386 20 17.8578 19.6808 17.8578 19.2857V5.52009C17.8578 5.33036 17.7819 5.14732 17.648 5.01339ZM16.2105 5.84821H12.0096V1.64732L16.2105 5.84821ZM16.2507 18.3929H3.7507V1.60714H10.4918V6.42857C10.4918 6.67721 10.5905 6.91567 10.7664 7.09148C10.9422 7.2673 11.1806 7.36607 11.4293 7.36607H16.2507V18.3929Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_522_3446">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
